import { constants } from '../constants'
import { common } from './common'

export const pushNotificationUtil = {
    getNotificationSetUpStatus: status => {
        return status === 'Complete' || status === 'Scheduled' || status === 'Sent'
            ? 'Complete'
            : status
    },
    getNotificationStatus: status => {
        return status === 'Ready' ? 'Complete' : status === 'Completed' ? 'Sent' : status
    },
    isNotificationSent: status => status === 'Completed' || false,
    isNotificationPublished: status => status === 'Scheduled' || status === 'Completed',
    isNotificationIncomplete: status => status === 'Not Started' || status === 'Incomplete',
    isNotificationReady: status => status === 'Ready',
    getFilteredSetupStatus: list => {
        const mappedStatus = list.map(status => {
            return status === 'Complete' ? 'Ready' : status === 'Sent' ? 'Completed' : status
        })
        return mappedStatus
    },
    mapNotificationStatuses: list => {
        const map = {
            Complete: 'Ready',
            Sent: 'Completed',
        }
        const mappedList = list.reduce((acc, status) => {
            acc.push(map[status] ? map[status] : status)
            return acc
        }, [])
        return mappedList
    },
    getStateCodeFromValue: stateValues => {
        return Array.from(stateValues)
            .reduce((acc, state) => {
                acc.push(
                    state === 'National'
                        ? 'all'
                        : common.getKeyByValue(constants.statesList || [], state)
                )
                return acc
            }, [])
            .filter(state => state)
    },
    parseNotificationRegions: (region, state) => {
        if (!region) {
            return []
        }
        let regions = region
        if (region.length === 0) {
            if (state.length !== 0) {
                regions = state
                    .filter(region => constants.statesList[region] !== undefined)
                    .map(region => {
                        return {
                            country: 'US',
                            state: region,
                        }
                    })
            }
            // else if (
            //     is_national ||
            //     ((status === 'Completed' || status === 'Scheduled' || status === 'Ready') &&
            //         send_to_nonspecified === 'N')
            // ) {
            //     regions = [{ country: 'US' }]
            // }
        }
        return regions
    },
    parsePushNotificationFilters: filters => {
        const updatedFilters = { ...filters }
        if (filters && filters.state && filters.state.includes('all')) {
            updatedFilters['is_national'] = true
            updatedFilters['state'] = filters.state.filter(state => state !== 'all')
            if (updatedFilters['state'].length === 0) {
                delete updatedFilters['state']
            }
        }
        return updatedFilters
    },
}
